export default __webpack_public_path__ + "static/media/YarnDyed.97da6cbd.webp";